<template>
  <div>
    <el-table
      class="table-list"
      ref="multipleTable"
      :data="dataList"
      @row-click="clickFn"
      @row-dblclick="dblclickFn"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column v-for="(th,index) in tableTh" :key="index" :prop="th.name" :label="th.label"></el-table-column>
      <el-table-column label="路由地址" prop="routeUrl" v-if="functionType === 2">
        <template slot-scope="scope">
          <span>{{scope.row.routeUrl}}</span>
        </template>
      </el-table-column>
      <el-table-column label="组件名" prop="component" v-if="functionType === 2">
        <template slot-scope="scope">
          <span>{{scope.row.component}}</span>
        </template>
      </el-table-column>
      <el-table-column label="资源类型" prop="type">
        <template slot-scope="scope">
          <el-tag :type="oTypeColor[scope.row.type]" v-if="scope.row.type">{{oType[scope.row.type]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作类型" prop="getway">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.operateType">{{operate[scope.row.operateType]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="oStateType[scope.row.state]" v-if="scope.row.state !== null">{{oState[scope.row.state]}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

const operate = {
  0: '登录',
  1: '查询',
  2: '新增',
  3: '修改',
  4: '删除',
  5: '打印',
  6: '导出',
  7: '启用',
  8: '停用',
  9: '审核'
};
const oType = {
  1: '按钮',
  2: '隐藏权限',
  3: '组件初始化'
};
const oTypeColor = {
  1: 'success',
  2: 'info',
  3: 'warning'
};
const oState = {
  1: '启用',
  0: '停用'
};
const oStateType = {
  1: 'success',
  0: 'danger'
};
export default {
  name: 'list',
  props: {
    dataList: {
      type: Array
    },
    functionType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      oType,
      oTypeColor,
      operate,
      oState,
      oStateType,
      tableTh: [
        {
          name: 'code',
          label: '编号'
        },
        {
          name: 'name',
          label: '资源名称'
        },
        {
          name: 'getway',
          label: '网关'
        },
        {
          name: 'afterUrl',
          label: 'API地址'
        }
      ],
      oActiveItem: null,
      bShowEditDialog: false
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      this.dataList.forEach(item => {
        item.checked = false;
      });
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    },
    clickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('detail');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
